angular.module('account').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('/account/views/accountActivation.html',
    "<form name=\"accountActivationForm\" ng-submit=\"activateAccount()\" novalidate>\r" +
    "\n" +
    "    <div ng-if=\"!loading\" class=\"panel-body panel-flush\">\r" +
    "\n" +
    "        <div class=\"panel-subheading\">\r" +
    "\n" +
    "            {{::'Account Information' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-12 col-md-6 col-xs-flush\">\r" +
    "\n" +
    "                <div class=\"form-group\">\r" +
    "\n" +
    "                    <label class=\"control-label\">{{::'Username' | translate}}</label>\r" +
    "\n" +
    "                    <ap-spinner ng-show=\"userNameLoading\"></ap-spinner>\r" +
    "\n" +
    "                    <input class=\"form-control\"\r" +
    "\n" +
    "                               name=\"UserName\"\r" +
    "\n" +
    "                               ng-model=\"accountActivationDto.UserName\"\r" +
    "\n" +
    "                               ng-change=\"activateAccountUserNameValidation()\"\r" +
    "\n" +
    "                               type=\"text\"\r" +
    "\n" +
    "                               placeholder=\"User Name\"\r" +
    "\n" +
    "                               ap-metadata\r" +
    "\n" +
    "                                >\r" +
    "\n" +
    "                    <span ng-show=\"accountActivationForm.UserName.$invalid && model.UserNameInUse\"\r" +
    "\n" +
    "                          class=\"help-block ng-hide\">\r" +
    "\n" +
    "                        {{::'User Name is not available.' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                    <span ng-show=\"accountActivationForm.UserName.$invalid && accountActivationForm.$submitted && !model.UserNameInUse\"\r" +
    "\n" +
    "                          class=\"help-block ng-hide\">\r" +
    "\n" +
    "                        {{::'User Name must be at least 5 characters.' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-12 col-md-6 col-xs-flush\">\r" +
    "\n" +
    "                <div class=\"form-group\"\r" +
    "\n" +
    "                     >\r" +
    "\n" +
    "                    <label class=\"control-label\">{{::'Password' | translate}}</label>\r" +
    "\n" +
    "                    <input class=\"form-control\"\r" +
    "\n" +
    "                           name=\"Password\"\r" +
    "\n" +
    "                           ng-model=\"accountActivationDto.Password\"\r" +
    "\n" +
    "                           type=\"password\"\r" +
    "\n" +
    "                           placeholder=\"New Password\"\r" +
    "\n" +
    "                           ap-metadata\r" +
    "\n" +
    "                            >\r" +
    "\n" +
    "                    <span ng-show=\"accountActivationForm.Password.$invalid && accountActivationForm.$submitted\"\r" +
    "\n" +
    "                          class=\"help-block ng-hide\">\r" +
    "\n" +
    "                            {{::'Password must be at least 5 characters.' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-12 col-md-6 col-xs-flush\">\r" +
    "\n" +
    "                <div class=\"form-group\"\r" +
    "\n" +
    "                     ng-class=\"{ 'has-error' : accountActivationForm.confirmPassword.$invalid && accountActivationForm.$submitted}\">\r" +
    "\n" +
    "                    <label class=\"control-label\">{{::'Retype Password' | translate}}</label>\r" +
    "\n" +
    "                    <input class=\"form-control\"\r" +
    "\n" +
    "                           name=\"confirmPassword\"\r" +
    "\n" +
    "                           ng-model=\"confirmNewPassword\"\r" +
    "\n" +
    "                           type=\"password\"\r" +
    "\n" +
    "                           placeholder=\"Retype Password\"\r" +
    "\n" +
    "                           ng-pattern=\"accountActivationDto.Password\"\r" +
    "\n" +
    "                           ap-required=\"true\"\r" +
    "\n" +
    "                            >\r" +
    "\n" +
    "                    <span ng-show=\"accountActivationForm.confirmPassword.$invalid && accountActivationForm.$submitted\"\r" +
    "\n" +
    "                          class=\"help-block ng-hide\">\r" +
    "\n" +
    "                            {{::'Passwords do not match.' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-6 col-md-3 col-flush-left\">\r" +
    "\n" +
    "                <button type=\"button\" class=\"btn btn-default2 btn-lg\" ng-click=\"back()\">{{'Back' | translate}}</button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-6 col-md-3 col-flush-right\">\r" +
    "\n" +
    "                <button type=\"submit\" class=\"btn btn-default1 btn-lg pull-right\"\r" +
    "\n" +
    "                        ng-disabled=\"submitLoading\">\r" +
    "\n" +
    "                    <ap-spinner ng-show=\"submitLoading\"></ap-spinner>\r" +
    "\n" +
    "                    {{'Submit' | translate}}\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"loading\">\r" +
    "\n" +
    "        <div class=\"text-center\" ng-if=\"loading\">\r" +
    "\n" +
    "            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</form>"
  );


  $templateCache.put('/account/views/accountActivationRequest.html',
    "<form name=\"accountRequestValidationForm\" ng-submit=\"activateAccountRequest()\">\r" +
    "\n" +
    "    <div ng-if=\"!loading && !httpError\" class=\"panel-body panel-flush\">\r" +
    "\n" +
    "        <div class=\"panel-subheading\">\r" +
    "\n" +
    "            {{::'Personal Information' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-12 col-md-6 col-xs-flush\">\r" +
    "\n" +
    "                <div class=\"form-group\">\r" +
    "\n" +
    "                    <label class=\"control-label\">{{::'Email Address' | translate}}</label>\r" +
    "\n" +
    "                    <input class=\"form-control\"\r" +
    "\n" +
    "                           name=\"EmailAddress\"\r" +
    "\n" +
    "                           ng-model=\"accountActivationDto.EmailAddress\"\r" +
    "\n" +
    "                           type=\"text\"\r" +
    "\n" +
    "                           placeholder=\"\"\r" +
    "\n" +
    "                           ap-metadata\r" +
    "\n" +
    "                            >\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-12 col-md-6 col-xs-flush\">\r" +
    "\n" +
    "                <div class=\"form-group\">\r" +
    "\n" +
    "                <label class=\"control-label\">{{::'Birthdate' | translate}}</label>\r" +
    "\n" +
    "                    <ap-form-answer-date question=\"question\"\r" +
    "\n" +
    "                                         answer=\"accountActivationDto.Birthdate\"></ap-form-answer-date>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-6 col-md-3 col-flush-left\">\r" +
    "\n" +
    "                <button type=\"button\" class=\"btn btn-default2 btn-lg\" ng-click=\"back()\">{{'Back' | translate}}</button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-6 col-md-3 col-flush-right\">\r" +
    "\n" +
    "                <button type=\"submit\" class=\"btn btn-default1 btn-lg pull-right\"\r" +
    "\n" +
    "                        ng-disabled=\"submitLoading\">\r" +
    "\n" +
    "                    <ap-spinner ng-show=\"submitLoading\"></ap-spinner>\r" +
    "\n" +
    "                    {{'Submit' | translate}}\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "        <div class=\"text-center\" ng-if=\"loading\">\r" +
    "\n" +
    "            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-if=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{::'An error has occurred and the page could not be loaded.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-if=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "            {{::'You do not have access to this info.'| translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</form>"
  );


  $templateCache.put('/account/views/accountdetails.html',
    "<div id=\"account-details\" class=\"container-fluid container-flush\" ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-demo non-mychart chart-label\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "                <div class=\"row\">\r" +
    "\n" +
    "                    <div class=\"col-xs-3\">\r" +
    "\n" +
    "                        <div class=\"account-details-tile\">\r" +
    "\n" +
    "                            <div class=\"dashboard-photo\" ng-if=\"patient.isPatient\">\r" +
    "\n" +
    "                                <img class=\"rounded-corner-lg border-width-lg extra-dark-grey-border\"\r" +
    "\n" +
    "                                     lazy-src=\"{{::patient.loginUserId | apPatientPortalThumbnailSrc:150:150}}\" endpoint-base='patient' alt=\"patient-image\">\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"dashboard-patient\" ng-if=\"patient.isPatient\">\r" +
    "\n" +
    "                                {{::'Patient'|translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"dashboard-patient\" ng-if=\"!patient.isPatient\">\r" +
    "\n" +
    "                                {{::'Responsible Party'|translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"dashboard-name\">\r" +
    "\n" +
    "                                <span class=\"dashboard-name\">{{::patient.name}}</span>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"dashboard-date\" ng-if=\"patient.birthDate\">\r" +
    "\n" +
    "                                <ap-date-formatter date=\"{{::patient.birthDate}}\" format=\"long-date\"></ap-date-formatter>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"col-xs-9\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"panel-heading panel-flush\">\r" +
    "\n" +
    "                            <div class=\"panel-title\">\r" +
    "\n" +
    "                                {{:: 'Account Details' | translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"panel-body panel-flush\">\r" +
    "\n" +
    "                            <div class=\"row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-6 col-flush-left\">\r" +
    "\n" +
    "                                    <form name=\"loginCredentialsForm\" ng-submit=\"saveCredentials(loginCredentialsForm)\" novalidate>\r" +
    "\n" +
    "                                        <div class=\"row panel-subheading flexbox flexbox-horizontal-center\">\r" +
    "\n" +
    "                                            <span class=\"title\">{{::'Login Credentials' | translate}}</span>\r" +
    "\n" +
    "                                            <span class=\"flexbox-pull-right\">\r" +
    "\n" +
    "                                                <button id=\"save-credentials-btn\" class=\"btn btn-default2\" ng-if=\"isEditingCredentials\"\r" +
    "\n" +
    "                                                        type=\"submit\" ng-disabled=\"isSavingCredentials\">\r" +
    "\n" +
    "                                                    {{::'Save' | translate}}\r" +
    "\n" +
    "                                                    <span ng-if=\"isSavingCredentials\"><ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "                                                </button>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                <button id=\"edit-credentials-btn\" class=\"btn btn-default2\" ng-show=\"(!isEditingCredentials && !isEditingQuestionAnswers)\"\r" +
    "\n" +
    "                                                        type=\"button\" ng-click=\"editCredentials()\">\r" +
    "\n" +
    "                                                    {{::'Edit' | translate}}\r" +
    "\n" +
    "                                                </button>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                <button id=\"cancel-credentials-btn\" class=\"btn btn-default2\" ng-if=\"isEditingCredentials\"\r" +
    "\n" +
    "                                                        type=\"button\" ng-click=\"cancelCredentials(loginCredentialsForm)\">\r" +
    "\n" +
    "                                                    {{::'Cancel' | translate}}\r" +
    "\n" +
    "                                                </button>\r" +
    "\n" +
    "                                            </span>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                        <div class=\"row\">\r" +
    "\n" +
    "                                            <label class=\"control-label\">{{::'UserName' | translate}}</label>\r" +
    "\n" +
    "                                            <div>\r" +
    "\n" +
    "                                                <p class=\"form-control-static\">\r" +
    "\n" +
    "                                                    {{securityAccountCredentialsDto.UserName}}\r" +
    "\n" +
    "                                                </p>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                            <div ng-if=\"!isEditingCredentials\">\r" +
    "\n" +
    "                                                <label class=\"control-label\">{{::'Password' | translate}}</label>\r" +
    "\n" +
    "                                                <p class=\"form-control-static\">\r" +
    "\n" +
    "                                                <span ng-if=\"!securityAccountCredentialsDto.NewPassword\">\r" +
    "\n" +
    "                                                    {{::'********'}}\r" +
    "\n" +
    "                                                </span>\r" +
    "\n" +
    "                                                <span ng-if=\"securityAccountCredentialsDto.NewPassword\">\r" +
    "\n" +
    "                                                    {{securityAccountCredentialsDto.NewPassword}}\r" +
    "\n" +
    "                                                </span>\r" +
    "\n" +
    "                                                </p>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                            <div class=\"form-group\" ng-if=\"isEditingCredentials\"\r" +
    "\n" +
    "                                                 ng-class=\"{ 'has-error' : (loginCredentialsForm.oldpassword.$invalid && loginCredentialsForm.$submitted)}\">\r" +
    "\n" +
    "                                                <label class=\"control-label\">{{::'Old Password' | translate}}</label>\r" +
    "\n" +
    "                                                <input class=\"form-control\"\r" +
    "\n" +
    "                                                       id=\"oldpassword\"\r" +
    "\n" +
    "                                                       name=\"oldpassword\"\r" +
    "\n" +
    "                                                       ng-model=\"securityAccountCredentialsDto.OldPassword\"\r" +
    "\n" +
    "                                                       type=\"password\"\r" +
    "\n" +
    "                                                       placeholder=\"Old Password goes here\"\r" +
    "\n" +
    "                                                       ap-metadata>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                            <div class=\"form-group\" ng-if=\"isEditingCredentials\"\r" +
    "\n" +
    "                                                 ng-class=\"{ 'has-error' : (loginCredentialsForm.newpassword.$invalid && loginCredentialsForm.$submitted)}\">\r" +
    "\n" +
    "                                                <label class=\"control-label\">{{::'New Password' | translate}}</label>\r" +
    "\n" +
    "                                                <input class=\"form-control\"\r" +
    "\n" +
    "                                                       id=\"newpassword\"\r" +
    "\n" +
    "                                                       name=\"newpassword\"\r" +
    "\n" +
    "                                                       ng-model=\"securityAccountCredentialsDto.NewPassword\"\r" +
    "\n" +
    "                                                       type=\"password\"\r" +
    "\n" +
    "                                                       placeholder=\"New Password goes here\"\r" +
    "\n" +
    "                                                       ap-metadata\r" +
    "\n" +
    "                                                        >\r" +
    "\n" +
    "                                                <span ng-show=\"loginCredentialsForm.newpassword.$invalid && loginCredentialsForm.$submitted\"\r" +
    "\n" +
    "                                                      class=\"help-block ng-hide\">\r" +
    "\n" +
    "                                                        {{::'Password must be at least 5 characters.' | translate}}\r" +
    "\n" +
    "                                                </span>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                            <div ng-if=\"validationMessage && isEditingCredentials\" class=\"text-danger\">\r" +
    "\n" +
    "                                                {{ validationMessage }}\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </form>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                <div class=\"col-xs-6 col-flush-right\">\r" +
    "\n" +
    "                                    <form name=\"securityQuestionAnswersForm\" novalidate>\r" +
    "\n" +
    "                                        <div class=\"row panel-subheading flexbox flexbox-horizontal-center\">\r" +
    "\n" +
    "                                            <span class=\"title\">{{::'Security Questions' | translate}}</span>\r" +
    "\n" +
    "                                            <span class=\"flexbox-pull-right\">\r" +
    "\n" +
    "                                                <button id=\"save-question-answers-btn\" class=\"btn btn-default2\" ng-if=\"isEditingQuestionAnswers\"\r" +
    "\n" +
    "                                                        type=\"submit\" ng-click=\"saveQuestionAnswers(securityQuestionAnswersForm)\" ng-disabled=\"isSavingQuestionAnswers\">\r" +
    "\n" +
    "                                                    {{::'Save' | translate}}\r" +
    "\n" +
    "                                                    <span ng-if=\"isSavingQuestionAnswers\"><ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "                                                </button>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                <button id=\"edit-question-answers-btn\" class=\"btn btn-default2\" ng-show=\"(!isEditingQuestionAnswers && !isEditingCredentials)\"\r" +
    "\n" +
    "                                                        type=\"button\" ng-click=\"editQuestionAnswers()\">\r" +
    "\n" +
    "                                                    {{::'Edit' | translate}}\r" +
    "\n" +
    "                                                </button>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                <button id=\"cancel-question-answers-btn\" class=\"btn btn-default2\" ng-if=\"isEditingQuestionAnswers\"\r" +
    "\n" +
    "                                                        type=\"button\" ng-click=\"cancelQuestionAnswers(securityQuestionAnswersForm)\">\r" +
    "\n" +
    "                                                    {{::'Cancel' | translate}}\r" +
    "\n" +
    "                                                </button>\r" +
    "\n" +
    "                                            </span>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                        <div class=\"row\" ng-repeat=\"patientSecurityQuestion in securityAccountQuestionsAnswersDto.Questions\">\r" +
    "\n" +
    "                                            <!-- Question -->\r" +
    "\n" +
    "                                            <div ng-if=\"!isEditingQuestionAnswers\">\r" +
    "\n" +
    "                                                <label class=\"control-label\">{{::'Security Question ' | translate}} {{ $index + 1 }}</label>\r" +
    "\n" +
    "                                                <p class=\"form-control-static\">\r" +
    "\n" +
    "                                                    {{patientSecurityQuestion.Text}}\r" +
    "\n" +
    "                                                </p>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                            <div class=\"form-group\" ng-if=\"isEditingQuestionAnswers\">\r" +
    "\n" +
    "                                                <label class=\"control-label\">{{::'Security Question ' | translate}} {{ $index + 1 }}</label>\r" +
    "\n" +
    "                                                    <select class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "                                                            name=\"question_{{$index}}\"\r" +
    "\n" +
    "                                                            id=\"question_{{$index}}\"\r" +
    "\n" +
    "                                                            ng-model=\"patientSecurityQuestion.Id\"\r" +
    "\n" +
    "                                                            ng-options=\"securityQuestion.Id as securityQuestion.Text for securityQuestion in securityQuestions\"\r" +
    "\n" +
    "                                                            ng-change=\"selectedQuestionChanged(patientSecurityQuestion)\"\r" +
    "\n" +
    "                                                            ap-metadata=\"metadata.Fields.Questions.Fields.Id\">\r" +
    "\n" +
    "                                                    </select>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                            <!-- Answer -->\r" +
    "\n" +
    "                                            <div ng-if=\"!isEditingQuestionAnswers\">\r" +
    "\n" +
    "                                                <label class=\"control-label\">{{::'Answer' | translate}} {{ $index + 1 }}</label>\r" +
    "\n" +
    "                                                <p class=\"form-control-static\">\r" +
    "\n" +
    "                                                <span ng-if=\"!patientSecurityQuestion.Answer\">\r" +
    "\n" +
    "                                                    {{::'****************'}}\r" +
    "\n" +
    "                                                </span>\r" +
    "\n" +
    "                                                <span ng-if=\"patientSecurityQuestion.Answer\">\r" +
    "\n" +
    "                                                    {{patientSecurityQuestion.Answer}}\r" +
    "\n" +
    "                                                </span>\r" +
    "\n" +
    "                                                </p>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                            <div class=\"form-group\" ng-if=\"isEditingQuestionAnswers\"\r" +
    "\n" +
    "                                                 ng-class=\"{ 'has-error' : (securityQuestionAnswersForm['answer_' + $index].$invalid\r" +
    "\n" +
    "                                                    && securityQuestionAnswersForm['answer_' + $index].$dirty)}\">\r" +
    "\n" +
    "                                                <label class=\"control-label\">{{::'Answer' | translate}} {{ $index + 1 }}</label>\r" +
    "\n" +
    "                                                <input class=\"form-control\"\r" +
    "\n" +
    "                                                       id=\"answer_{{$index}}\"\r" +
    "\n" +
    "                                                       name=\"answer_{{$index}}\"\r" +
    "\n" +
    "                                                       ng-model=\"patientSecurityQuestion.Answer\"\r" +
    "\n" +
    "                                                       type=\"text\"\r" +
    "\n" +
    "                                                       placeholder=\"Answer goes here\"\r" +
    "\n" +
    "                                                       ap-metadata=\"metadata.Fields.Questions.Fields.Answer\">\r" +
    "\n" +
    "                                                <span ng-show=\"securityQuestionAnswersForm['answer_' + $index].$invalid && securityQuestionAnswersForm.$submitted\"\r" +
    "\n" +
    "                                                      class=\"help-block ng-hide\">\r" +
    "\n" +
    "                                                        {{::'Answer must be at least 4 characters.' | translate}}\r" +
    "\n" +
    "                                                </span>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                        <div ng-if=\"validationMessage && isEditingQuestionAnswers\" class=\"text-danger\">\r" +
    "\n" +
    "                                            {{ validationMessage }}\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                    </form>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "                <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                    <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                    {{::'An error has occurred and Account Details could not be loaded.' | translate}}\r" +
    "\n" +
    "                </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                    {{::'You do not have access to Account Details.' | translate}}\r" +
    "\n" +
    "                </uib-alert>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/account/views/accountsetup.html',
    "<div ng-if=\"!loading && !httpError\" class=\"panel-body panel-flush\">\r" +
    "\n" +
    "<form name=\"editPatientDetailsForm\">\r" +
    "\n" +
    "<div class=\"panel-subheading\">\r" +
    "\n" +
    "    {{::'Insurance Details' | translate}}\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div>\r" +
    "\n" +
    "        <span>{{::'Upload a photo of your primary insurance card' | translate}}</span>\r" +
    "\n" +
    "            <ap-select-image\r" +
    "\n" +
    "                max-size-kb=\"primaryInsuranceImageModel.maxSizeKb\"\r" +
    "\n" +
    "                selected-file-name=\"primaryInsuranceImageModel.selectedFileName\"\r" +
    "\n" +
    "                selected-mime-type=\"primaryInsuranceImageModel.selectedMimeType\"\r" +
    "\n" +
    "                selected-file-contents=\"primaryInsuranceImageModel.selectedFileContents\">\r" +
    "\n" +
    "            </ap-select-image>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div>\r" +
    "\n" +
    "        ---------------------- {{::'OR'|translate}} ---------------------\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"row\">\r" +
    "\n" +
    "        <div class=\"col-xs-6\">\r" +
    "\n" +
    "            <label class=\"control-label\">{{::'Insurance Provider' | translate}}</label>\r" +
    "\n" +
    "                <select\r" +
    "\n" +
    "                        class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "                        name=\"insuranceProvider1\"\r" +
    "\n" +
    "                        ng-model=\"createAccountDto.PrimaryInsurance.InsuranceCarrier\"\r" +
    "\n" +
    "                        ng-change=\"updatePrimaryInsuranceList()\"\r" +
    "\n" +
    "                        ng-options=\"insuranceCarrier as insuranceCarrier.Name for insuranceCarrier in insuranceCarriers\"\r" +
    "\n" +
    "                        >\r" +
    "\n" +
    "                </select>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"col-xs-6\">\r" +
    "\n" +
    "            <label class=\"control-label \">{{::'Insurance Plan' | translate}}</label>\r" +
    "\n" +
    "                <select\r" +
    "\n" +
    "                        class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "                        name=\"insurancePlan1\"\r" +
    "\n" +
    "                        ng-model=\"createAccountDto.PrimaryInsurance.InsurancePlan\"\r" +
    "\n" +
    "                        ng-options=\"insurancePlan as insurancePlan.Name for insurancePlan in primaryInsurancePlansModified\"\r" +
    "\n" +
    "                        >\r" +
    "\n" +
    "                </select>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"row\">\r" +
    "\n" +
    "        <div class=\"col-xs-6\">\r" +
    "\n" +
    "            <label class=\"control-label\">{{::'Primary Account Holder First Name' |\r" +
    "\n" +
    "                translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"form-group\">\r" +
    "\n" +
    "                <input class=\"form-control\"\r" +
    "\n" +
    "                       id=\"accountFirstName1\"\r" +
    "\n" +
    "                       name=\"accountFirstName1\"\r" +
    "\n" +
    "                       ng-model=\"createAccountDto.PrimaryInsurance.AccountFirstName\"\r" +
    "\n" +
    "                       type=\"text\"\r" +
    "\n" +
    "                       placeholder=\"\"\r" +
    "\n" +
    "                        >\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"col-xs-6\">\r" +
    "\n" +
    "            <label class=\"control-label\">{{::'Primary Account Holder Last Name' |\r" +
    "\n" +
    "                translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"form-group\">\r" +
    "\n" +
    "                <input class=\"form-control\"\r" +
    "\n" +
    "                       id=\"accountLastName1\"\r" +
    "\n" +
    "                       name=\"accountLastName1\"\r" +
    "\n" +
    "                       ng-model=\"createAccountDto.PrimaryInsurance.AccountLastName\"\r" +
    "\n" +
    "                       type=\"text\"\r" +
    "\n" +
    "                       placeholder=\"\"\r" +
    "\n" +
    "                        >\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"row\">\r" +
    "\n" +
    "        <div class=\"col-xs-6\">\r" +
    "\n" +
    "            <label class=\"control-label\">{{::'Policy No.' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"form-group\">\r" +
    "\n" +
    "                <input class=\"form-control\"\r" +
    "\n" +
    "                       id=\"policyNumber1\"\r" +
    "\n" +
    "                       name=\"policyNumber1\"\r" +
    "\n" +
    "                       ng-model=\"createAccountDto.PrimaryInsurance.PolicyNumber\"\r" +
    "\n" +
    "                       type=\"text\"\r" +
    "\n" +
    "                       placeholder=\"\"\r" +
    "\n" +
    "                        >\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"col-xs-6\">\r" +
    "\n" +
    "            <label class=\"control-label\">{{::'Group No.' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"form-group\">\r" +
    "\n" +
    "                <input class=\"form-control\"\r" +
    "\n" +
    "                       id=\"groupNumber1\"\r" +
    "\n" +
    "                       name=\"groupNumber1\"\r" +
    "\n" +
    "                       ng-model=\"createAccountDto.PrimaryInsurance.GroupNumber\"\r" +
    "\n" +
    "                       type=\"text\"\r" +
    "\n" +
    "                       placeholder=\"\"\r" +
    "\n" +
    "                        >\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div ng-show=\"viewSecondaryInsurance\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div>\r" +
    "\n" +
    "        <span>{{'Upload a photo of your secondary insurance card' | translate}}\r" +
    "\n" +
    "            <!--  <input name=\"file\" type=\"file\" style=\"cursor:hand;\"/></div>  -->\r" +
    "\n" +
    "\r" +
    "\n" +
    "<!--\r" +
    "\n" +
    "            <ap-select-image\r" +
    "\n" +
    "                    max-size-kb=\"secondaryInsuranceImageModel.maxSizeKb\"\r" +
    "\n" +
    "                    selected-file-name=\"secondaryInsuranceImageModel.selectedFileName\"\r" +
    "\n" +
    "                    selected-mime-type=\"secondaryInsuranceImageModel.selectedMimeType\"\r" +
    "\n" +
    "                    selected-file-contents=\"secondaryInsuranceImageModel.selectedFileContents\">\r" +
    "\n" +
    "            </ap-select-image>\r" +
    "\n" +
    "-->\r" +
    "\n" +
    "\r" +
    "\n" +
    "        </span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div>\r" +
    "\n" +
    "        ---------------------- {{::'OR'|translate}} ---------------------\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"row\">\r" +
    "\n" +
    "        <div class=\"col-xs-6\">\r" +
    "\n" +
    "            <label class=\"control-label\">{{::'Insurance Provider' | translate}}</label>\r" +
    "\n" +
    "                <select\r" +
    "\n" +
    "                        class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "                        name=\"insuranceProvider2\"\r" +
    "\n" +
    "                        ng-model=\"createAccountDto.SecondaryInsurance.InsuranceCarrier\"\r" +
    "\n" +
    "                        ng-change=\"updateSecondaryInsuranceList()\"\r" +
    "\n" +
    "                        ng-options=\"insuranceCarrier as insuranceCarrier.Name for insuranceCarrier in insuranceCarriers\"\r" +
    "\n" +
    "                        >\r" +
    "\n" +
    "                </select>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"col-xs-6\">\r" +
    "\n" +
    "            <label class=\"control-label\">{{::'Insurance Plan' | translate}}</label>\r" +
    "\n" +
    "                <select\r" +
    "\n" +
    "                        class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "                        name=\"insurancePlan2\"\r" +
    "\n" +
    "                        ng-model=\"createAccountDto.SecondaryInsurance.InsurancePlan\"\r" +
    "\n" +
    "                        ng-options=\"insurancePlan as insurancePlan.Name for insurancePlan in secondaryInsurancePlansModified\"\r" +
    "\n" +
    "                        >\r" +
    "\n" +
    "                </select>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"row\">\r" +
    "\n" +
    "        <div class=\"col-xs-6\">\r" +
    "\n" +
    "            <label class=\"control-label\">{{::'Primary Account Holder First Name' |\r" +
    "\n" +
    "                translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"form-group\">\r" +
    "\n" +
    "                <input class=\"form-control\"\r" +
    "\n" +
    "                       id=\"accountFirstName2\"\r" +
    "\n" +
    "                       name=\"accountFirstName2\"\r" +
    "\n" +
    "                       ng-model=\"createAccountDto.SecondaryInsurance.AccountFirstName\"\r" +
    "\n" +
    "                       type=\"text\"\r" +
    "\n" +
    "                       placeholder=\"\"\r" +
    "\n" +
    "                        >\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"col-xs-6\">\r" +
    "\n" +
    "            <label class=\"control-label\">{{::'Primary Account Holder Last Name' |\r" +
    "\n" +
    "                translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"form-group\">\r" +
    "\n" +
    "                <input class=\"form-control\"\r" +
    "\n" +
    "                       id=\"accountLastName2\"\r" +
    "\n" +
    "                       name=\"accountLastName2\"\r" +
    "\n" +
    "                       ng-model=\"createAccountDto.SecondaryInsurance.AccountLastName\"\r" +
    "\n" +
    "                       type=\"text\"\r" +
    "\n" +
    "                       placeholder=\"\"\r" +
    "\n" +
    "                        >\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"row\">\r" +
    "\n" +
    "        <div class=\"col-xs-6\">\r" +
    "\n" +
    "            <label class=\"control-label\">{{::'Policy No.' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"form-group\">\r" +
    "\n" +
    "                <input class=\"form-control\"\r" +
    "\n" +
    "                       id=\"policyNumber2\"\r" +
    "\n" +
    "                       name=\"policyNumber2\"\r" +
    "\n" +
    "                       ng-model=\"createAccountDto.SecondaryInsurance.PolicyNumber\"\r" +
    "\n" +
    "                       type=\"text\"\r" +
    "\n" +
    "                       placeholder=\"\"\r" +
    "\n" +
    "                        >\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"col-xs-6\">\r" +
    "\n" +
    "            <label class=\"control-label\">{{::'Group No.' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"form-group\">\r" +
    "\n" +
    "                <input class=\"form-control\"\r" +
    "\n" +
    "                       id=\"groupNumber2\"\r" +
    "\n" +
    "                       name=\"groupNumber2\"\r" +
    "\n" +
    "                       ng-model=\"createAccountDto.SecondaryInsurance.GroupNumber\"\r" +
    "\n" +
    "                       type=\"text\"\r" +
    "\n" +
    "                       placeholder=\"\"\r" +
    "\n" +
    "                        >\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "<button class=\"btn btn-default1\" ng-click=\"toggleViewSecondaryInsurance()\"><span ng-if=\"!viewSecondaryInsurance\">Add Secondary Insurance</span>\r" +
    "\n" +
    "    <span ng-if=\"viewSecondaryInsurance\">Remove Secondary Insurance</span></button>\r" +
    "\n" +
    "<div class=\"panel-subheading\">\r" +
    "\n" +
    "    {{::'Security Information' | translate}}\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div>\r" +
    "\n" +
    "    <label class=\"control-label\">{{::'Security Question 1' | translate}}</label>\r" +
    "\n" +
    "        <select\r" +
    "\n" +
    "                class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "                name=\"question1\"\r" +
    "\n" +
    "                ng-model=\"step2createAccountDto.SecurityQuestion[1].Question\"\r" +
    "\n" +
    "                ng-options=\"securityQuestion as securityQuestion.Text for securityQuestion in securityQuestions\"\r" +
    "\n" +
    "                >\r" +
    "\n" +
    "        </select>\r" +
    "\n" +
    "    <label class=\"control-label\">{{::'Answer' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"form-group\">\r" +
    "\n" +
    "        <input class=\"form-control\"\r" +
    "\n" +
    "               id=\"answer1\"\r" +
    "\n" +
    "               name=\"answer1\"\r" +
    "\n" +
    "               ng-model=\"createAccountDto.SecurityQuestions[1].Answer\"\r" +
    "\n" +
    "               type=\"text\"\r" +
    "\n" +
    "               placeholder=\"Type your answer and make sure it is something you can remember\"\r" +
    "\n" +
    "                >\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div>\r" +
    "\n" +
    "    <label class=\"control-label\">{{::'Security Question 2' | translate}}</label>\r" +
    "\n" +
    "        <select\r" +
    "\n" +
    "                class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "                name=\"question2\"\r" +
    "\n" +
    "                ng-model=\"step2createAccountDto.SecurityQuestion[2].Question\"\r" +
    "\n" +
    "                ng-options=\"securityQuestion as securityQuestion.Text for securityQuestion in securityQuestions\"\r" +
    "\n" +
    "                >\r" +
    "\n" +
    "        </select>\r" +
    "\n" +
    "    <label class=\"control-label\">{{::'Answer' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"form-group\">\r" +
    "\n" +
    "        <input class=\"form-control\"\r" +
    "\n" +
    "               id=\"answer2\"\r" +
    "\n" +
    "               name=\"answer2\"\r" +
    "\n" +
    "               ng-model=\"createAccountDto.SecurityQuestions[2].Answer\"\r" +
    "\n" +
    "               type=\"text\"\r" +
    "\n" +
    "               placeholder=\"Type your answer and make sure it is something you can remember\"\r" +
    "\n" +
    "                >\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div>\r" +
    "\n" +
    "    <label class=\"control-label\">{{::'Security Question 3' | translate}}</label>\r" +
    "\n" +
    "        <select\r" +
    "\n" +
    "                class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "                name=\"question3\"\r" +
    "\n" +
    "                ng-model=\"step2createAccountDto.SecurityQuestion[3].Question\"\r" +
    "\n" +
    "                ng-options=\"securityQuestion as securityQuestion.Text for securityQuestion in securityQuestions\"\r" +
    "\n" +
    "                >\r" +
    "\n" +
    "        </select>\r" +
    "\n" +
    "    <label class=\"control-label\">{{::'Answer' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"form-group\">\r" +
    "\n" +
    "        <input class=\"form-control\"\r" +
    "\n" +
    "               id=\"answer3\"\r" +
    "\n" +
    "               name=\"answer3\"\r" +
    "\n" +
    "               ng-model=\"createAccountDto.SecurityQuestions[3].Answer\"\r" +
    "\n" +
    "               type=\"text\"\r" +
    "\n" +
    "               placeholder=\"Type your answer and make sure it is something you can remember\"\r" +
    "\n" +
    "                >\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "</form>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "    <div class=\"text-center\" ng-if=\"loading\">\r" +
    "\n" +
    "        <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <uib-alert type=\"danger\" ng-if=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "        {{::'An error has occurred and the page could not be loaded.' | translate}}\r" +
    "\n" +
    "    </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <uib-alert type=\"danger\" ng-if=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "        {{::'You do not have access to this info.'| translate}}\r" +
    "\n" +
    "    </uib-alert>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div class=\"panel-footer\">\r" +
    "\n" +
    "    <span>\r" +
    "\n" +
    "        <button class=\"btn btn-default2\" ng-click=\"back()\">{{::'Back' | translate}}</button>\r" +
    "\n" +
    "        <button class=\"btn btn-default2\" ng-click=\"skip()\">{{::'Skip' | translate}}</button>\r" +
    "\n" +
    "        <button class=\"btn btn-default1\" ng-click=\"next()\">{{::'Next' | translate}}</button>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/account/views/accountvalidation.html',
    "<div ng-if=\"!loading && !httpError\" class=\"panel-body panel-flush\">\r" +
    "\n" +
    "    <div class=\"panel-subheading\">\r" +
    "\n" +
    "        {{::'Personal Information' | translate}}\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <form name=\"accountValidationForm\">\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-6\">\r" +
    "\n" +
    "                <label class=\"control-label\">{{::'Driver\\'s License Number' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div class=\"form-group\">\r" +
    "\n" +
    "                    <input class=\"form-control\"\r" +
    "\n" +
    "                           id=\"driversLicenseNumber\"\r" +
    "\n" +
    "                           name=\"driversLicenseNumber\"\r" +
    "\n" +
    "                           ng-model=\"accountValidationDto.DriversLicenseNumber\"\r" +
    "\n" +
    "                           type=\"text\"\r" +
    "\n" +
    "                           placeholder=\"\"\r" +
    "\n" +
    "                           ap-required\r" +
    "\n" +
    "                            >\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-6\">\r" +
    "\n" +
    "                <label class=\"control-label\">{{::'Driver\\'s License Issue State' | translate}}</label>\r" +
    "\n" +
    "                    <select\r" +
    "\n" +
    "                            class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "                            name=\"driversLicenseState\"\r" +
    "\n" +
    "                            ng-model=\"accountValidationDto.DriversLicenseState\"\r" +
    "\n" +
    "                            ng-options=\"driversLicenseState as driversLicenseState.Description for driversLicenseState in driversLicenseStates\"\r" +
    "\n" +
    "                            ap-required\r" +
    "\n" +
    "                            >\r" +
    "\n" +
    "                    </select>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </form>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "    <div class=\"text-center\" ng-if=\"loading\">\r" +
    "\n" +
    "        <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <uib-alert type=\"danger\" ng-if=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "        {{::'An error has occurred and the page could not be loaded.' | translate}}\r" +
    "\n" +
    "    </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <uib-alert type=\"danger\" ng-if=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "        {{::'You do not have access to this info.'| translate}}\r" +
    "\n" +
    "    </uib-alert>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div class=\"panel-footer\">\r" +
    "\n" +
    "    <div class=\"col-xs-4 col-sm-3 col-md-2 col-flush\">\r" +
    "\n" +
    "        <button class=\"btn btn-default2\" ng-click=\"back()\">{{'Back' | translate}}</button>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"col-xs-4 col-sm-3 col-md-2 col-flush col-xs-offset-1 col-md-offset-0\">\r" +
    "\n" +
    "        <button class=\"btn btn-default1\" ng-click=\"next()\">{{'Next' | translate}}</button>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/account/views/aprimaconditions.html',
    "<div ng-if=\"!loading && !httpError\" class=\"panel-body panel-flush\">\r" +
    "\n" +
    "    <div class=\"panel-subheading\">\r" +
    "\n" +
    "        {{::'Aprima Terms & Conditions' | translate}}\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"row\">\r" +
    "\n" +
    "        <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "            <div class=\"form-group\">\r" +
    "\n" +
    "                <label class=\"control-label\">{{::'Patient Portal Terms and Conditions' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <p>\r" +
    "\n" +
    "                    <iframe ng-src=\"{{PDFPath}}\" class=\"ap-consent-terms-conditions\"></iframe>\r" +
    "\n" +
    "                </p>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "    <div class=\"text-center\" ng-if=\"loading\">\r" +
    "\n" +
    "        <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <uib-alert type=\"danger\" ng-if=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "        {{\"An error has occurred and the consent info could not be loaded.\" | translate}}\r" +
    "\n" +
    "    </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <uib-alert type=\"danger\" ng-if=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "        {{\"You do not have access to this info.\"| translate}}\r" +
    "\n" +
    "    </uib-alert>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div class=\"panel-footer\">\r" +
    "\n" +
    "    <span>\r" +
    "\n" +
    "        <button class=\"btn btn-default2\" ng-click=\"back()\">{{'Back' | translate}}</button>\r" +
    "\n" +
    "        <button class=\"btn btn-primary\" ng-click=\"finish()\">{{'Finish' | translate}}</button>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "\r" +
    "\n"
  );


  $templateCache.put('/account/views/changepassword.html',
    "<form name=\"changePasswordForm\" ng-submit=\"submit()\" novalidate>\r" +
    "\n" +
    "    <div ng-if=\"!loading && !httpError\" class=\"panel-body panel-flush\">\r" +
    "\n" +
    "        <div class=\"panel-subheading\">\r" +
    "\n" +
    "            {{::'Please create a new password:' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "                <div class=\"row\">\r" +
    "\n" +
    "                    <div class=\"col-xs-6\">\r" +
    "\n" +
    "                        <div class=\"form-group\"\r" +
    "\n" +
    "                                 ng-class=\"{ 'has-error' : changePasswordForm.oldPassword.$invalid && changePasswordForm.$submitted}\">\r" +
    "\n" +
    "                            <label class=\"control-label\" for=\"oldPassword\">{{::'Old Password' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div class=\"form-group\">\r" +
    "\n" +
    "                                <input class=\"form-control\"\r" +
    "\n" +
    "                                       id=\"oldPassword\"\r" +
    "\n" +
    "                                       name=\"oldPassword\"\r" +
    "\n" +
    "                                       ng-model=\"model.OldPassword\"\r" +
    "\n" +
    "                                       type=\"password\"\r" +
    "\n" +
    "                                       placeholder=\"Old Password\"\r" +
    "\n" +
    "                                       ng-disabled=\"showSecurityQuestions\"\r" +
    "\n" +
    "                                       required\r" +
    "\n" +
    "                                        >\r" +
    "\n" +
    "                                <span ng-show=\"changePasswordForm.oldPassword.$invalid && changePasswordForm.$submitted\"\r" +
    "\n" +
    "                                      class=\"help-block ng-hide\">\r" +
    "\n" +
    "                                {{::'Not valid.' | translate}}\r" +
    "\n" +
    "                                </span>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-6\">\r" +
    "\n" +
    "                <div class=\"form-group\"\r" +
    "\n" +
    "                     ng-class=\"{ 'has-error' : changePasswordForm.newPassword.$invalid && changePasswordForm.$submitted}\">\r" +
    "\n" +
    "                    <label class=\"control-label\" for=\"newPassword\">{{::'New Password' | translate}}</label>\r" +
    "\n" +
    "                    <input class=\"form-control\"\r" +
    "\n" +
    "                           id=\"newPassword\"\r" +
    "\n" +
    "                           name=\"newPassword\"\r" +
    "\n" +
    "                           ng-model=\"model.NewPassword\"\r" +
    "\n" +
    "                           type=\"password\"\r" +
    "\n" +
    "                           placeholder=\"New Password\"\r" +
    "\n" +
    "                           ng-minlength=\"5\"\r" +
    "\n" +
    "                           required\r" +
    "\n" +
    "                            >\r" +
    "\n" +
    "                    <span ng-show=\"changePasswordForm.newPassword.$invalid && changePasswordForm.$submitted\"\r" +
    "\n" +
    "                          class=\"help-block ng-hide\">\r" +
    "\n" +
    "                            {{::'Password must be at least 5 characters.' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-6\">\r" +
    "\n" +
    "                <div class=\"form-group\"\r" +
    "\n" +
    "                     ng-class=\"{ 'has-error' : changePasswordForm.confirmNewPassword.$invalid && changePasswordForm.$submitted}\">\r" +
    "\n" +
    "                    <label class=\"control-label\" for=\"confirmNewPassword\">{{::'Retype New Password' | translate}}</label>\r" +
    "\n" +
    "                    <input class=\"form-control\"\r" +
    "\n" +
    "                           id=\"confirmNewPassword\"\r" +
    "\n" +
    "                           name=\"confirmNewPassword\"\r" +
    "\n" +
    "                           ng-model=\"confirmNewPassword\"\r" +
    "\n" +
    "                           type=\"password\"\r" +
    "\n" +
    "                           placeholder=\"Retype Password\"\r" +
    "\n" +
    "                           ng-pattern=\"model.NewPassword\"\r" +
    "\n" +
    "                           required\r" +
    "\n" +
    "                            >\r" +
    "\n" +
    "                    <span ng-show=\"changePasswordForm.confirmNewPassword.$invalid && changePasswordForm.$submitted\"\r" +
    "\n" +
    "                          class=\"help-block ng-hide\">\r" +
    "\n" +
    "                            {{::'Passwords do not match.' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"panel-footer panel-flush\">\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-6 col-flush-left\">\r" +
    "\n" +
    "                    <button type=\"button\" class=\"btn btn-default2 btn-lg\" ng-click=\"back()\">{{'Back' | translate}}</button>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-6 col-flush-right\">\r" +
    "\n" +
    "                    <button type=\"submit\" class=\"btn btn-primary btn-lg pull-right\"\r" +
    "\n" +
    "                            ng-disabled=\"loading\">\r" +
    "\n" +
    "                        <ap-spinner ng-show=\"loading\"></ap-spinner>\r" +
    "\n" +
    "                        {{'Submit' | translate}}\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "        <div class=\"text-center\" ng-if=\"loading\">\r" +
    "\n" +
    "            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-if=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{\"An error has occurred and the page could not be loaded.\" | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-if=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "            {{\"You do not have access to this info.\"| translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</form>"
  );


  $templateCache.put('/account/views/createaccountlayout.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-demo\">\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-1 col-sm-2\"></div>\r" +
    "\n" +
    "            <div class=\"col-xs-10 col-sm-8 col-flush\">\r" +
    "\n" +
    "                <div class=\"panel-heading panel-flush text-center\">\r" +
    "\n" +
    "                    {{::'Complete your account' | translate}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div ui-view></div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-1 col-sm-2\"></div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/account/views/emailoptout.html',
    "<form name=\"emailoptoutForm\" ng-submit=\"submit()\" novalidate>\r" +
    "\n" +
    "    <div ng-if=\"!loading && !httpError\" class=\"panel-body panel-flush\">\r" +
    "\n" +
    "        <div class=\"panel-subheading\">\r" +
    "\n" +
    "            {{::'Opt Out Email: ' | translate}} {{model.EmailAddress}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-6\">\r" +
    "\n" +
    "                <div class=\"form-group\">\r" +
    "\n" +
    "                    <input class=\"col-xs-3\" type=\"checkbox\" name=\"isOptOutStatement\" id=\"isOptOutStatement\"\r" +
    "\n" +
    "                            ng-model=\"model.IsOptOutStatement\" >\r" +
    "\n" +
    "                    <label for=\"isOptOutStatement\"></label>\r" +
    "\n" +
    "                    <label class=\"col-xs-2 col-xs-offset-1\" for=\"isOptOutStatement\">Statements</label>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"panel-footer panel-flush\">\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-6 col-flush-right\">\r" +
    "\n" +
    "                    <label class=\"pull-right\" ng-disabled=\"loading || invalidAccessCode\" ng-show=\"processed\">\r" +
    "\n" +
    "                        <ap-spinner ng-show=\"loading\"></ap-spinner>\r" +
    "\n" +
    "                        {{'Success' | translate}}\r" +
    "\n" +
    "                    </label>\r" +
    "\n" +
    "                    <button type=\"submit\" class=\"btn btn-primary btn-lg pull-right\"\r" +
    "\n" +
    "                        ng-disabled=\"loading || invalidAccessCode\" ng-hide=\"processed\">\r" +
    "\n" +
    "                        <ap-spinner ng-show=\"loading\"></ap-spinner>\r" +
    "\n" +
    "                        {{'Submit' | translate}}\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"loading || httpError || invalidAccessCode\">\r" +
    "\n" +
    "        <div class=\"text-center\" ng-if=\"loading\">\r" +
    "\n" +
    "            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-if=\"invalidAccessCode\" ng-cloak>\r" +
    "\n" +
    "            {{\"Access Code is invalid in URL.\" | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-if=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{\"An error has occurred and the page could not be loaded.\" | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-if=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "            {{\"You do not have access to this info.\"| translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</form>"
  );


  $templateCache.put('/account/views/emailoptoutlayout.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-demo\">\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-1 col-sm-2\"></div>\r" +
    "\n" +
    "            <div class=\"col-xs-10 col-sm-8 col-flush\">\r" +
    "\n" +
    "                <div class=\"panel-heading panel-flush text-center\">\r" +
    "\n" +
    "                    {{::'Email Opt Out' | translate}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div ui-view></div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-1 col-sm-2\"></div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/account/views/forgotpassword.html',
    "<form name=\"changePasswordForm\" ng-submit=\"submit()\" novalidate>\r" +
    "\n" +
    "    <div ng-if=\"!loading && !httpError\" class=\"panel-body panel-flush\">\r" +
    "\n" +
    "        <div class=\"panel-subheading\">\r" +
    "\n" +
    "            {{::'Please create a new password:' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-12\">\r" +
    "\n" +
    "                <div class=\"form-group\"\r" +
    "\n" +
    "                     ng-class=\"{ 'has-error' : changePasswordForm.answer1.$invalid && changePasswordForm.$submitted}\">\r" +
    "\n" +
    "                <label class=\"control-label\" for=\"answer1\">{{model.Questions[0].Text}}</label>\r" +
    "\n" +
    "                <input class=\"form-control\"\r" +
    "\n" +
    "                       id=\"answer1\"\r" +
    "\n" +
    "                       name=\"answer1\"\r" +
    "\n" +
    "                       ng-model=\"Answers.Question1\"\r" +
    "\n" +
    "                       type=\"text\"\r" +
    "\n" +
    "                       placeholder=\"Answer 1\"\r" +
    "\n" +
    "                       required\r" +
    "\n" +
    "                        >\r" +
    "\n" +
    "                            <span ng-show=\"changePasswordForm.answer1.$invalid && changePasswordForm.$submitted\"\r" +
    "\n" +
    "                                  class=\"help-block ng-hide\">\r" +
    "\n" +
    "                            {{::'Not valid.' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"form-group\"\r" +
    "\n" +
    "                     ng-class=\"{ 'has-error' : changePasswordForm.answer2.$invalid && changePasswordForm.$submitted}\">\r" +
    "\n" +
    "                <label class=\"control-label\" for=\"answer2\">{{model.Questions[1].Text}}</label>\r" +
    "\n" +
    "                <input class=\"form-control\"\r" +
    "\n" +
    "                       id=\"answer2\"\r" +
    "\n" +
    "                       name=\"answer2\"\r" +
    "\n" +
    "                       ng-model=\"Answers.Question2\"\r" +
    "\n" +
    "                       type=\"text\"\r" +
    "\n" +
    "                       placeholder=\"Answer 2\"\r" +
    "\n" +
    "                       required\r" +
    "\n" +
    "                        >\r" +
    "\n" +
    "                            <span ng-show=\"changePasswordForm.answer2.$invalid && changePasswordForm.$submitted\"\r" +
    "\n" +
    "                                  class=\"help-block ng-hide\">\r" +
    "\n" +
    "                            {{::'Not valid.' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"form-group\"\r" +
    "\n" +
    "                     ng-class=\"{ 'has-error' : changePasswordForm.answer3.$invalid && changePasswordForm.$submitted}\">\r" +
    "\n" +
    "                <label class=\"control-label\" for=\"answer3\">{{model.Questions[2].Text}}</label>\r" +
    "\n" +
    "                <input class=\"form-control\"\r" +
    "\n" +
    "                       id=\"answer3\"\r" +
    "\n" +
    "                       name=\"answer3\"\r" +
    "\n" +
    "                       ng-model=\"Answers.Question3\"\r" +
    "\n" +
    "                       type=\"text\"\r" +
    "\n" +
    "                       placeholder=\"Answer 3\"\r" +
    "\n" +
    "                       required\r" +
    "\n" +
    "                        >\r" +
    "\n" +
    "                            <span ng-show=\"changePasswordForm.answer3.$invalid && changePasswordForm.$submitted\"\r" +
    "\n" +
    "                                  class=\"help-block ng-hide\">\r" +
    "\n" +
    "                            {{::'Not valid.' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-12\">\r" +
    "\n" +
    "                <div class=\"form-group\"\r" +
    "\n" +
    "                     ng-class=\"{ 'has-error' : changePasswordForm.newPassword.$invalid && changePasswordForm.$submitted}\">\r" +
    "\n" +
    "                    <label class=\"control-label\" for=\"newPassword\">{{::'New Password' | translate}}</label>\r" +
    "\n" +
    "                    <input class=\"form-control\"\r" +
    "\n" +
    "                           id=\"newPassword\"\r" +
    "\n" +
    "                           name=\"newPassword\"\r" +
    "\n" +
    "                           ng-model=\"model.NewPassword\"\r" +
    "\n" +
    "                           type=\"password\"\r" +
    "\n" +
    "                           placeholder=\"New Password\"\r" +
    "\n" +
    "                           ng-minlength=\"5\"\r" +
    "\n" +
    "                           required\r" +
    "\n" +
    "                            >\r" +
    "\n" +
    "                    <span ng-show=\"changePasswordForm.newPassword.$invalid && changePasswordForm.$submitted\"\r" +
    "\n" +
    "                          class=\"help-block ng-hide\">\r" +
    "\n" +
    "                            {{::'Password must be at least 5 characters.' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-12\">\r" +
    "\n" +
    "                <div class=\"form-group\"\r" +
    "\n" +
    "                     ng-class=\"{ 'has-error' : changePasswordForm.confirmNewPassword.$invalid && changePasswordForm.$submitted}\">\r" +
    "\n" +
    "                    <label class=\"control-label\" for=\"confirmNewPassword\">{{::'Retype New Password' | translate}}</label>\r" +
    "\n" +
    "                    <input class=\"form-control\"\r" +
    "\n" +
    "                           id=\"confirmNewPassword\"\r" +
    "\n" +
    "                           name=\"confirmNewPassword\"\r" +
    "\n" +
    "                           ng-model=\"confirmNewPassword\"\r" +
    "\n" +
    "                           type=\"password\"\r" +
    "\n" +
    "                           placeholder=\"Retype Password\"\r" +
    "\n" +
    "                           ng-pattern=\"model.NewPassword\"\r" +
    "\n" +
    "                           required\r" +
    "\n" +
    "                            >\r" +
    "\n" +
    "                    <span ng-show=\"changePasswordForm.confirmNewPassword.$invalid && changePasswordForm.$submitted\"\r" +
    "\n" +
    "                          class=\"help-block ng-hide\">\r" +
    "\n" +
    "                            {{::'Passwords do not match.' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"panel-footer text-center\">\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-1 col-sm-2 col-md-3\"></div>\r" +
    "\n" +
    "                <div class=\"col-xs-5 col-sm-4 col-md-3\">\r" +
    "\n" +
    "                    <button type=\"submit\" class=\"btn btn-primary btn-lg btn-block\"\r" +
    "\n" +
    "                            ng-disabled=\"loading\">\r" +
    "\n" +
    "                        <ap-spinner ng-show =\"loading\"></ap-spinner>\r" +
    "\n" +
    "                        {{'Submit' | translate}}\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-5 col-sm-4 col-md-3\">\r" +
    "\n" +
    "                    <button class=\"btn btn-default2 btn-lg btn-block\" ng-click=\"back()\">{{::'Back' | translate}}</button>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-1 col-sm-2 col-md-3\"></div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "        <div class=\"text-center\" ng-if=\"loading\">\r" +
    "\n" +
    "            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-if=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{::'An error has occurred and the page could not be loaded.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-if=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "            {{::'You do not have access to this info.'| translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</form>"
  );


  $templateCache.put('/account/views/loginconsent.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div id=\"login-consent-panel\" class=\"panel panel-primary\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"panel panel-default panel-flush\">\r" +
    "\n" +
    "            <div class=\"panel-body\">\r" +
    "\n" +
    "                <form name=\"loginConsentForm\" ng-submit=\"submitForm()\" novalidate>\r" +
    "\n" +
    "                    <div class=\"row\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                            <div class=\"form-group\">\r" +
    "\n" +
    "                                <label class=\"control-label\">{{::'Aprima Consent' | translate}}</label>\r" +
    "\n" +
    "                                <p class=\"form-control-static\">\r" +
    "\n" +
    "                                    {{::loginConsent.AprimaConsent}}\r" +
    "\n" +
    "                                </p>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"row\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                            <div class=\"form-group\">\r" +
    "\n" +
    "                                <label class=\"control-label\">{{::'Patient Portal Terms and Conditions' | translate}}</label>\r" +
    "\n" +
    "                                <ap-document-viewer-with-download\r" +
    "\n" +
    "                                    disable-inline-pdf=\"model.DisableInlinePdf\"\r" +
    "\n" +
    "                                    document-id=\"model.DocumentId\"\r" +
    "\n" +
    "                                    enable-download=\"model.DocumentId\"\r" +
    "\n" +
    "                                    document-download=\"downloadPrivacyPolicy()\"\r" +
    "\n" +
    "                                    document-load=\"getPrivacyPolicy()\"\r" +
    "\n" +
    "                                ></ap-document-viewer-with-download>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"row\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                            <div class=\"form-group\">\r" +
    "\n" +
    "                                <label class=\"control-label\">{{::'Practice Consent' | translate}}</label>\r" +
    "\n" +
    "                                <p class=\"form-control-static\" ng-bind-html=\"loginConsent.PracticeConsentText\"></p>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"row\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                            <div class=\"form-group\">\r" +
    "\n" +
    "                                <label style=\"word-wrap: break-word\" for=\"agreeToConsentCheckbox\">\r" +
    "\n" +
    "                                    <input type=\"checkbox\" id=\"agreeToConsentCheckbox\" name=\"agreeToConsentCheckbox\"\r" +
    "\n" +
    "                                           ng-model=\"LoginConsentVm.agreeToConsentChecked\"  required/>\r" +
    "\n" +
    "                                    &nbsp;&nbsp;{{loginConsent.AgreeCheckboxText}}\r" +
    "\n" +
    "                                </label>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div>\r" +
    "\n" +
    "                            <div ng-show=\"loginConsentForm.$submitted || loginConsentForm.agreeToConsentCheckbox.$touched\">\r" +
    "\n" +
    "                                <div ng-show=\"loginConsentForm.agreeToConsentCheckbox.$error.required\"\r" +
    "\n" +
    "                                     class=\"text-danger\">\r" +
    "\n" +
    "                                    {{loginConsent.ConsentWarningMessage}}\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"row\">\r" +
    "\n" +
    "                        <div class=\"col-xs-1 col-sm-2 col-md-3\">&nbsp;</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"col-xs-5 col-sm-4 col-md-3\">\r" +
    "\n" +
    "                            <button id=\"disagreeBtn\" type=\"button\" class=\"btn btn-default2 btn-lg btn-block\"\r" +
    "\n" +
    "                                    ng-click=\"disagreeToConsent()\">\r" +
    "\n" +
    "                                <i class=\"fa fa-4x\"></i>\r" +
    "\n" +
    "                                {{::'Disagree' | translate}}\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"col-xs-5 col-sm-4 col-md-3\">\r" +
    "\n" +
    "                            <button id=\"agreeBtn\" type=\"submit\" class=\"btn btn-primary btn-lg btn-block\">\r" +
    "\n" +
    "                                <span class=\"ng-hide\" ng-show=\"submitted\"><ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "                                <i class=\"fa fa-4x\"></i>\r" +
    "\n" +
    "                                {{::'Agree' | translate}}\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"col-xs-1 col-sm-2 col-md-3\">&nbsp;</div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                </form>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "                <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                    <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                    {{::'An error has occurred and the login consent could not be loaded.' | translate}}\r" +
    "\n" +
    "                </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                    {{::'You do not have access to login consent page.' | translate}}\r" +
    "\n" +
    "                </uib-alert>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "\r" +
    "\n"
  );

}]);
